<template>
  <div
    class="study-ranges-aside sttranasd std_cont_tabs"
    data-tst="ranges_aside"
  >
    <TabBox
      v-if="hasTableTile"
      class="sttranasd_tabbox"
      :swKey="gameformat?.stream_url ? 'sw_tabs_tabletile_icm_events' : 'sw_tabs_tabletile'"
      style="--tbbox-overflow-y: hidden"
      data-tst="ranges_aside_tabs_tabletile"
    >
      <template #default="{ tab }">
        <div class="std_cont">
          <StudyTableTile
            v-if="tab === 'poker_table_tile'"
            :hSpot="hSpot"
            :gameformat="gameformat"
            :street="street"
            :mobile="mobile"
            :hasPlayers="true"
            :solElite="solElite"
          />

          <div
            v-if="tab === 'stream_url'"
            style="margin: 0.5rem; width: 100%"
          >
            <GwVideoPlayer
              v-if="streamVideo.src"
              :key="streamVideo.src"
              type="youtube"
              style="
                overflow: hidden;
                margin: auto;
                min-width: 16rem;
                max-width: 40rem;
                max-height: 25rem;
                border-radius: 12px;
                aspect-ratio: 16/9;
                background: black;
              "
              :autoplay="false"
              :src="streamVideo.src"
              :start="streamVideo.start"
            />
          </div>

          <div
            v-if="tab === 'poker_table' || tab === 'eq_chart'"
            class="flex-1 gw_table-box-layout"
            style="gap: 1rem; padding: 0.5rem 0.25rem"
          >
            <PokerTableStudy
              v-if="tab === 'poker_table'"
              :spot="hSpot"
              :namespace
              :gameformat="gameformat"
              class="flex-1 gw_table-box-layout_pokertable"
              style="
                min-width: 28rem;
                font-size: 0.75rem;
                min-height: 14rem;
                --margin-horizontal: 0;
                --cards-space: 0;
                padding: 2rem;
                --clr-table-back: var(--clr-black-0-3);
              "
            />

            <template v-if="$store.getters.user_has_flag('SOL_3WAY')">
              <EquityChartComplex2
                v-if="tab === 'eq_chart'"
                :hasTitle="false"
                :hasGuide="false"
                style="
                  overflow: hidden;
                  padding: 1rem 0rem 0 0.325rem;
                  --legend-players-inset: 0.75rem auto auto 1.5rem;
                  --legend-controls-inset: -0.75rem auto auto 1rem;
                  margin: -1rem 0 0 0;
                  min-width: 28rem;
                  min-height: 15rem;
                "
                styleLegend="
                 --legend-size: 0.8rem;
                 --legend-circle-size: 10px;
                "
                styleSvg="
                --stroke-width: 3;
                --clr-svg-back: rgba(255, 255, 255, 0.025);
                "
                :skeleton="!showFlopContent || !playerDetail"
                :hands="showFlopContent ? combos : []"
                :rangeKey="viewProps.rangeKey"
                :players="players"
                :activeHands="activeHandsForPlayers"
                :player="viewProps.player"
                @combos:mouseenter="handleEqChartMouseEnter"
              >
                <MessageOverlaySkeleton
                  v-if="!showFlopContent"
                  class="gw_mesblock_container"
                  :isBlurred="true"
                  :isTopDown="true"
                  style="
                    --radius: 4px;
                    left: -0.25rem;
                    top: -0.35rem;
                    height: calc(100% + 0.45rem);
                    width: calc(100% + 0.25rem);
                  "
                >
                  <MessagesGoPostflop
                    :namespace="namespace"
                    :canAISolve="canAISolve"
                    class="mt-2"
                    :title="$t('messages.select_postflop_spot')"
                  >
                  </MessagesGoPostflop>
                </MessageOverlaySkeleton>
              </EquityChartComplex2>
            </template>
            <!-- TODO rm after 3way rls -->
            <template v-else>
              <EquityChartComplex
                v-if="tab === 'eq_chart'"
                :hasTitle="false"
                :hasGuide="false"
                style="
                  overflow: hidden;
                  padding: 1rem 0rem 0 0.325rem;
                  --legend-players-inset: 0.75rem auto auto 1.5rem;
                  --legend-controls-inset: -0.75rem auto auto 1rem;
                  margin: -1rem 0 0 0;
                "
                styleLegend="
                 --legend-size: 0.8rem;
                 --legend-circle-size: 10px;
                "
                styleSvg="
                --stroke-width: 3;
                --clr-svg-back: rgba(255, 255, 255, 0.025);
                "
                :skeleton="!showFlopContent || !hero"
                :hands="showFlopContent ? combos : []"
                :rangeKey="viewProps.rangeKey"
                :hero="hero"
                :opponent="opponent"
                :handsHero="filteredHeroHandsIds"
                :handsOpponent="filteredOpponentHandsIds"
                :handsActiveOpponent="
                  tabBreakdown
                    ? []
                    : heroGroupId
                      ? []
                      : tableMouseover || opponentGroupId
                        ? opponentHandsIds
                        : []
                "
                :handsActiveHero="
                  tabBreakdown && heroHand
                    ? [heroHand.id]
                    : opponentGroupId
                      ? []
                      : tableMouseover || heroGroupId
                        ? heroHandsIds
                        : []
                "
                :player="viewProps.player"
                @combos:mouseenter="
                  ({ hand_0: hand_hero, hand_1: hand_opponent }) => {
                    handleEqChartMouseEnter([hand_hero, hand_opponent])
                  }
                "
              >
                <MessageOverlaySkeleton
                  v-if="!showFlopContent"
                  class="gw_mesblock_container"
                  :isBlurred="true"
                  :isTopDown="true"
                  style="
                    --radius: 4px;
                    left: -0.25rem;
                    top: -0.35rem;
                    height: calc(100% + 0.45rem);
                    width: calc(100% + 0.25rem);
                  "
                >
                  <MessagesGoPostflop
                    :namespace="namespace"
                    :canAISolve="canAISolve"
                    class="mt-2"
                    :title="$t('messages.select_postflop_spot')"
                  >
                  </MessagesGoPostflop>
                </MessageOverlaySkeleton>
              </EquityChartComplex>
            </template>

            <StudyPlayersTable
              v-if="$store.getters.user_has_flag('SOL_3WAY')"
              style="min-width: 24rem"
              class="gw_table-box-layout_playersinfo"
              :asBlocks="false"
              :players="players"
              :bettingInfo
            />
            <!-- TODO rm after 3way rls -->
            <StudyPlayersTable
              v-else
              style="min-width: 14rem"
              class="gw_table-box-layout_playersinfo"
              :asBlocks="true"
              :players="[hero, opponent]"
              :bettingInfo
            />
          </div>
        </div>
      </template>
    </TabBox>
    <TabBox
      v-if="!smallLayout"
      class="sttranasd_tabbox"
      style="--tbbox-overflow-y: unset; --tbbox-overflow-x: unset"
      :scrollToActiveTab="false"
      :options="['singletab']"
      value="singletab"
      :hasNamedTabSlot="true"
    >
      <template #tab_singletab>
        <div
          @click="
            $store.dispatch('switchers_set_next', {
              key: 'sw_tabs_actions',
            })
          "
        >
          {{ $t(`tabs.${actiontab}`) }}
        </div>
        <GwMenu
          ref="gwmenu"
          @click.stop
        >
          <template #opener="{ value }">
            <div
              class="mdi text-semi-large icon_btn transition_03 mdi-menu-down gtabs_menu_icon"
              :class="{ rotated_180_before: value }"
              data-tst="tabs_actions_opener"
              style="margin: 0 -0.5rem 0 0.25rem; transition: 0.22s"
            />
          </template>
          <template #default="{ methods }">
            <GwBtns
              :tstPrefix="`actions_btn`"
              :value="actiontab"
              :options="optionsActions"
              idKey="payload"
              class="gwbtns_vertical_primary gw_menu"
              @click="
                (_e, item) => {
                  $store.dispatch('switchers_set_item', {
                    key: 'sw_tabs_actions',
                    item: { payload: item },
                  })
                  methods.toggleOpen(false)
                }
              "
            >
              <template #default="{ item }">
                {{ $t(`tabs.${item}`) }}
              </template>
            </GwBtns>
          </template>
        </GwMenu>
      </template>
      <template #default>
        <div
          class="std_cont"
          tour="strategyinfo"
          data-tst="ranges_aside_tabs_actions"
        >
          <div
            class="f-column flex-1"
            style="min-height: 11rem; min-width: 0; gap: 0.25rem"
          >
            <!-- TODO remove isPreflop ? -->
            <StudyActionBtns
              style="overflow: auto"
              :showActions="actiontab === 'actions'"
              :customSolution="solution_picked"
              :isPreflop="isPreflop"
              :showFlopContent="showFlopContent"
              :useHex="useHex"
              :showBetsIn="showBetsIn"
              :grouping="grouping"
              :catDraws="catDraws"
              :catHands="catHands"
              :filterActions="filterCombos.actions"
            />
            <StudyGraphSolutions
              v-show="actiontab === 'actions'"
              :customSolution="solution_picked"
              :useHex="useHex"
              :hasLegend="false"
              style="--chart-height: 1.5em; --chart-radius: 4px"
            />
          </div>
        </div>
      </template>
    </TabBox>

    <TabBox
      class="sttranasd_tabbox flex-1"
      :style="
        smallLayout && !landScapeLayout
          ? '--tbbox-content-max-height:var(--small-layout-aside-max-height);--tbbox-content-min-height:var(--small-layout-aside-max-height);'
          : smallLayout && landScapeLayout
            ? '--tbbox-content-max-height:var(--small-layout-aside-max-height);'
            : ''
      "
      :tabsStyle="smallLayout ? '--padding-inner:0 2.25rem 0 0;' : ''"
      :hasMinify="hasMinify"
      :swKey="
        smallLayout
          ? gameformat?.stream_url
            ? 'sw_tabs_handmatrix_all_icm_events'
            : 'sw_tabs_handmatrix_all'
          : gameformat?.stream_url
            ? 'sw_tabs_handmatrix_icm_events'
            : 'sw_tabs_handmatrix'
      "
      :scrollToActiveTab="smallLayout"
      :hasDragscroll="smallLayout"
      :hasNamedTabSlot="true"
      tstPrefix="ranges_aside_tabs_handmatrix"
    >
      <template #tab_blockers>
        {{ $t('tabs.blockers') }}
        <div
          style="position: absolute; right: 1px; top: 1px; font-size: 0.8rem"
          class="gw_hvr_content csst mdi mdi-help-circle-outline clr-grey icon_btn"
          @click="$store.dispatch('router_set_dialogs', 'blockers-tips-dialog')"
        ></div>
      </template>
      <template #tab_hands>
        {{ tabBreakdown ? $t('tabs.hand') : $t('tabs.hands') }}
        <template v-if="$store.getters.user_has_flag('SOL_3WAY')">
          {{ players[viewProps.player]?.position }}
        </template>
      </template>
      <template #tab_summary>
        {{ $t('tabs.summary') }}
        <template v-if="$store.getters.user_has_flag('SOL_3WAY')">
          {{ players[viewProps.player]?.position }}
        </template>
      </template>
      <template #tab_filters="{ value }">
        <div
          class="f-center std_noevents"
          style="gap: 0.5rem"
        >
          {{ $t('tabs.filters') }}
          <UnSwitcherNew
            :class="{ 'opacity_5 no-events': value !== 'filters' }"
            swKey="sw_study_filter_intersection"
            tstPrefix="studyfilter"
            style="--uns-opener-clr: inherit"
            @click="() => $store.dispatch('sol_filters_handle_mode_change')"
          />
        </div>
      </template>

      <template #default="{ tab }">
        <div
          data-tst="ranges_aside_handmatrix"
          class="flex-1 f-column std_cont swp_cont"
          tour="selectedcombos"
          @touchstart="swpHandleTouchStart"
          @touchmove="swpHandleTouchMove"
          @touchend="
            e =>
              swpHandleTouchEnd(e, {
                treshold: 40,
                timeout: 500,
                swKey: smallLayout ? 'sw_tabs_handmatrix_all' : 'sw_tabs_handmatrix',
              })
          "
        >
          <div
            v-if="tab === 'stream_url'"
            style="margin: 0.5rem; width: 100%"
          >
            <GwVideoPlayer
              v-if="streamVideo.src"
              :key="streamVideo.src"
              type="youtube"
              style="
                overflow: hidden;
                margin: auto;
                min-width: 16rem;
                max-width: 48rem;
                border-radius: 12px;
                aspect-ratio: 16/9;
                background: black;
              "
              :autoplay="false"
              :src="streamVideo.src"
              :start="streamVideo.start"
            />
          </div>

          <StudyCombos
            v-if="
              tab === 'hands' &&
              !tabBreakdown &&
              $store.getters.user_has_flag('SOL_3WAY') &&
              playerDetail
            "
            :player="viewProps.player"
            :group="playerDetail.group"
            :customHandsIds="playerDetail.hands_ids"
            :canBeLocked="playerDetail.is_hero"
            :viewProps="viewProps"
            :filterCombos="filterCombos"
            :filterEvCompare="filterEvCompare"
            :evProps="evProps"
            :mobile="mobile"
            :showFlopContent="showFlopContent"
            :grouping="grouping"
            :showBetsIn="showBetsIn"
            :rangeKey="viewProps.rangeKey"
            :showProp="playerDetail.range_content"
            :asEmpty="viewProps.player_emptyHands"
            :useHex="useHex"
            :hasPremiumGameformat="hasPremiumGameformat"
            :gameformat="gameformat"
            :rangeTab="rangeTab"
            :bettingInfo
          />
          <!-- TODO rm after 3way rls -->
          <StudyCombos
            v-if="tab === 'hands' && !tabBreakdown && !$store.getters.user_has_flag('SOL_3WAY')"
            :player="viewProps.player"
            :group="viewProps.player === '0' ? heroGroup : opponentGroup"
            :customHandsIds="viewProps.player === '0' ? heroHandsIds : opponentHandsIds"
            :canBeLocked="viewProps.player === '0'"
            :viewProps="viewProps"
            :filterCombos="filterCombos"
            :filterEvCompare="filterEvCompare"
            :evProps="evProps"
            :mobile="mobile"
            :showFlopContent="showFlopContent"
            :grouping="grouping"
            :showBetsIn="showBetsIn"
            :rangeKey="viewProps.rangeKey"
            :showProp="viewProps.player_showPropHands"
            :asEmpty="viewProps.player_emptyHands"
            :useHex="useHex"
            :hasPremiumGameformat="hasPremiumGameformat"
            :gameformat="gameformat"
            :rangeTab="rangeTab"
            :bettingInfo
          />

          <HandTableCell
            v-if="tab === 'hands' && tabBreakdown"
            style="
              border: solid var(--clr-black-0) 1px;
              overflow: hidden;
              border-radius: 4px;
              --htc-title-height: 2rem;
              --htc-title-size: 1.5rem;
              --htc-blocker-icon-size: 1.625rem;
              --htc-blocker-value-size: 1.5rem;
            "
            class="flex-1"
            :showFlopContent="showFlopContent"
            :gameformat="gameformat"
            :hasPremiumGameformat="hasPremiumGameformat"
            :combo="heroHand || { solution: [] }"
            :comboPlayer="heroHand ? heroHand.players[0] : null"
            player="0"
            :showBetsIn="showBetsIn"
            :grouping="grouping"
            :hasBlockers="true"
            :bettingInfo
            :hasLegend="true"
            :asEmpty="!heroHand || viewProps.player_emptyHands"
            :showProp="viewProps.hero_showPropHands"
            :evProps="evProps"
            :maximized="false"
            :maximizible="false"
            :rangeKey="viewProps.rangeKey"
            :filterEvCompare="filterEvCompare"
            :viewProps="viewProps"
            :rangeTab="rangeTab"
            :useHex="useHex"
            :filterCombos="filterCombos"
          >
            <template #legend_before>
              <UnSwitcherNew
                swKey="sw_hand_content"
                tstPrefix="breakdown"
                :hasText="true"
                :asMenu="false"
                style="
                  margin: 0 0 0.5rem auto;
                  --gwbtns-gap: 2px;
                  --gwbtn-padding: 0 0.5rem;
                  --gwbtn-clr-back: rgba(0, 0, 0, 0.25);
                  --gwbtn-clr-back: transparent;
                  --gwbtn-clr-active-white: rgba(0, 0, 0, 0.2);
                  --gwbtn-clr-hover-white: rgba(0, 0, 0, 0.2);
                  --gwbtn-clr: var(--clr-combo_text);
                  --gwbtn-clr-hover: var(--clr-combo_text);
                  --gwbtn-clr-active: var(--clr-combo_text);
                "
              />
            </template>
          </HandTableCell>

          <StudyFilters
            v-if="tab === 'filters'"
            :namespace="''"
            :gamestateNamespace="namespace"
            :canAISolve="canAISolve"
            :catDraws="catDraws"
            :catHands="catHands"
            :catEqBuckets="catEqBuckets"
            :catEqBucketsAdvanced="catEqBucketsAdvanced"
            :filterCategories="filterCategories"
            :mobile="mobile"
            :useHex="useHex"
            :showFlopContent="showFlopContent"
            :isPreflop="isPreflop"
            style="padding: 0.5rem"
          >
            <template #filter_pills>
              <StudyFiltersPills
                v-if="!mobile"
                class="no-shrink ml-auto flex-1 mb-auto"
                style="
                  --clr-pills-back: var(--clr-black-1);
                  max-width: 100%;
                  --active-margin-bottom: var(--ff-gap);
                "
                :alwaysVisible="false"
                :street="street"
                soltab="strategy"
                :filterCombos="filterCombos"
                :showBetsIn="showBetsIn"
              />
            </template>
          </StudyFilters>
          <BlockersTable
            v-if="tab === 'blockers'"
            :blockersFrequencies="blockersFrequencies"
            :namespace="namespace"
            :hasPremiumGameformat="hasPremiumGameformat"
            :solElite="solElite"
            :gameformat="gameformat"
            :actions="solution_picked"
            :showFlopContent="showFlopContent"
            :useHex="useHex"
            :grouping="grouping"
          />

          <template
            v-if="tab === 'summary' && $store.getters.user_has_flag('SOL_3WAY') && playerDetail"
          >
            <CombosTableOpponent
              v-if="!playerDetail?.is_hero"
              :opponentGroup="playerDetail.group"
              :showGroupCombos="!!playerDetail.group_id"
              :tableGroups="tableGroups"
              :mobile="mobile"
              :showFlopContent="showFlopContent"
              :bettingInfo
              :tableMouseover="tableMouseover"
              :player="viewProps.player"
              @combo:mouseenter="
                h =>
                  $store.dispatch('sol_detail_hover_hand', {
                    player: viewProps.player,
                    hand: h,
                    tableGroups,
                  })
              "
            />
            <CombosTableHero
              v-if="playerDetail?.is_hero"
              :heroGroup="playerDetail.group"
              :showGroupCombos="!!playerDetail.group_id"
              :tableGroups="tableGroups"
              :useHex="useHex"
              :mobile="mobile"
              :showFlopContent="showFlopContent"
              :showBetsIn="showBetsIn"
              :bettingInfo
              :grouping="grouping"
              :tableMouseover="tableMouseover"
              :hasPremiumGameformat="hasPremiumGameformat"
              :solElite="solElite"
              :gameformat="gameformat"
              @combo:mouseenter="
                h =>
                  $store.dispatch('sol_detail_hover_hand', {
                    player: viewProps.player,
                    hand: h,
                    tableGroups,
                  })
              "
            />
          </template>
          <!-- TODO rm after 3way rls -->
          <template v-else>
            <CombosTableOpponent
              v-if="tab === 'summary' && viewProps.player === '1'"
              :opponentGroup="opponentGroup"
              :player="viewProps.player"
              :showGroupCombos="!!opponentGroupId"
              :tableGroups="tableGroups"
              :mobile="mobile"
              :showFlopContent="showFlopContent"
              :bettingInfo
              :tableMouseover="tableMouseover"
              @combo:mouseenter="
                h =>
                  $store.dispatch('sol_detail_hover_hand', {
                    player: '1',
                    hand: h,
                    tableGroups,
                  })
              "
            />

            <CombosTableHero
              v-if="tab === 'summary' && viewProps.player === '0'"
              :heroGroup="heroGroup"
              :showGroupCombos="!!heroGroupId"
              :tableGroups="tableGroups"
              :useHex="useHex"
              :mobile="mobile"
              :showFlopContent="showFlopContent"
              :showBetsIn="showBetsIn"
              :bettingInfo
              :grouping="grouping"
              :tableMouseover="tableMouseover"
              :hasPremiumGameformat="hasPremiumGameformat"
              :solElite="solElite"
              :gameformat="gameformat"
              @combo:mouseenter="
                h =>
                  $store.dispatch('sol_detail_hover_hand', {
                    hand: h,
                    tableGroups,
                  })
              "
            />
          </template>

          <!-- // --- ALL together -->
          <div
            v-if="tab === 'actions' || tab === 'actions_chart'"
            class="f-column flex-1"
            style="gap: 0.25rem"
          >
            <StudyActionBtns
              style="overflow: auto"
              :customSolution="solution_picked"
              :isPreflop="isPreflop"
              :showFlopContent="showFlopContent"
              :useHex="useHex"
              :showBetsIn="showBetsIn"
              :showActions="tab === 'actions'"
              :grouping="grouping"
              :catDraws="catDraws"
              :catHands="catHands"
              :filterActions="filterCombos.actions"
              :hasBreakdown="false"
            />
            <StudyGraphSolutions
              :customSolution="solution_picked"
              :useHex="useHex"
              :hasLegend="false"
              style="--chart-height: 1.5em; --chart-radius: 4px"
            />
          </div>

          <TrainerRangesComparison
            v-if="tab === 'range_compare'"
            style="padding: 0.5rem"
            :catDraws="catDraws"
            :catEqBuckets="catEqBuckets"
            :catEqBucketsAdvanced="catEqBucketsAdvanced"
            :catHands="catHands"
            :filterCategories="filterCategories"
            :filterCombos="filterCombos"
            :hasGuides="true"
            :hasTitlePlayers="true"
            :isPreflop="isPreflop"
            :playerLeft="heroLeft ? hero : opponent"
            :playerRight="heroLeft ? opponent : hero"
            :playerLeftKey="heroLeft ? '0' : '1'"
            :playerRightKey="heroLeft ? '1' : '0'"
            :showFlopContent="showFlopContent"
            :street="street"
            @cat:mouseenter="category => $store.dispatch('sol_detail_highlight', category)"
            @cat:mouseleave="() => $store.dispatch('sol_detail_highlight', null)"
            @cat:click="
              ii => $store.dispatch('sol_filters_toggleCategory', { category: ii.category })
            "
          >
            <template #message>
              <MessagesGoPostflop
                v-if="!showFlopContent"
                :namespace="namespace"
                :canAISolve="canAISolve"
                class="mt-4 gw_mesblock_container"
                style="
                  --message-padding: 0.75rem;
                  --clr-title: var(--clr-grey-2);
                  --size-title: 0.8rem;
                  --weight-title: 500;
                  --btn-font-size: 0.7rem;
                  --btn-margin: 0.5rem 0 0 0;
                "
                :title="$t(`messages.eq_buckets_preflop`)"
              >
              </MessagesGoPostflop>
            </template>
          </TrainerRangesComparison>

          <EquityChartComplex
            v-if="tab === 'eq_chart'"
            style="
              padding: 0.25rem 0.5rem 0 0.5rem;
              --legend-controls-inset: -1rem auto auto 0.95rem;
            "
            styleLegend="
                 --legend-size: 0.8rem;
                 --legend-circle-size: 10px;
                 --legend-inset: 1rem auto auto 1.5rem;
                "
            styleSvg="
                --stroke-width: 3;
                --clr-svg-back: rgba(255, 255, 255, 0.025);
                "
            :skeleton="!showFlopContent || !hero"
            :hands="showFlopContent ? combos : []"
            :rangeKey="viewProps.rangeKey"
            :hero="hero"
            :opponent="opponent"
            :handsHero="filteredHeroHandsIds"
            :handsOpponent="filteredOpponentHandsIds"
            :handsActiveHero="tableMouseover || heroGroupId ? heroHandsIds : []"
            :handsActiveOpponent="tableMouseover || opponentGroupId ? opponentHandsIds : []"
            :player="viewProps.player"
          >
            <MessageOverlaySkeleton
              v-if="!showFlopContent"
              class="gw_mesblock_container"
              :isBlurred="true"
              :isTopDown="true"
              style="
                --radius: 4px;
                left: -0.25rem;
                top: -0.35rem;
                height: calc(100% + 0.45rem);
                width: calc(100% + 0.25rem);
              "
            >
              <MessagesGoPostflop
                class="mt-2"
                :namespace="namespace"
                :canAISolve="canAISolve"
                :title="$t('messages.select_postflop_spot')"
              >
              </MessagesGoPostflop>
            </MessageOverlaySkeleton>
          </EquityChartComplex>

          <EvComparePicker
            v-if="tab === 'ev_compare'"
            class="ma-auto"
            :instaApply="true"
          />
        </div>
      </template>
    </TabBox>
  </div>
</template>

<script>
import MessagesGoPostflop from '@/components/Poker/Overlays/Messages/MessagesGoPostflop'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import PokerTableStudy from '@/components/PokerTable/PokerTableStudy'
import TabBox from '@/components/lib/TabBox'
import GwMenu from '@/components/lib/GwMenu'
import GwBtns from '@/components/lib/GwBtns'
import GwVideoPlayer from '@/components/lib/GwVideoPlayer.vue'
import StudyPlayersTable from '@/components/DataTables/v2/tables/StudyPlayersTable/StudyPlayersTable'
import CombosTableHero from '@/components/DataTables/v2/tables/CombosTable/CombosTableHero'
import CombosTableOpponent from '@/components/DataTables/v2/tables/CombosTable/CombosTableOpponent'
import BlockersTable from '@/components/DataTables/v2/tables/BlockersTable/BlockersTable'
import StudyFiltersPills from '@/components/Study/StudyFiltersPills'
import UnSwitcherNew from '@/components/Switchers/UnSwitcher_new'
import { allSwitchers } from '@/store/switchers/switchers'

import StudyGraphSolutions from '@/components/Study/StudyGraphSolutions'
import StudyTableTile from '@/components/Study/StudyTableTile'
import StudyActionBtns from '@/components/Study/StudyActionBtns'
import StudyCombos from '@/components/Study/StudyCombos'
import EquityChartComplex from '@/components/Charts/LineCharts/EquityChartComplex'
import EquityChartComplex2 from '@/components/Charts/LineCharts/EquityChartComplex2'
import StudyFilters from '@/components/Study/StudyFilters'
import TrainerRangesComparison from '@/components/Trainer/TrainerRangesComparison'
import EvComparePicker from '@/components/EvComparePicker/EvComparePicker'
import HandTableCell from '@/components/Study/HandTableCell'

import swipe_mix from '@/mixins/swipe_mix'

export default {
  name: 'StudyRangesAside',
  components: {
    EquityChartComplex,
    EquityChartComplex2,
    StudyGraphSolutions,
    StudyTableTile,
    StudyActionBtns,
    StudyCombos,
    HandTableCell,
    StudyFilters,
    TrainerRangesComparison,
    EvComparePicker,
    MessagesGoPostflop,
    MessageOverlaySkeleton,
    PokerTableStudy,
    TabBox,
    GwMenu,
    GwBtns,
    StudyPlayersTable,
    CombosTableHero,
    CombosTableOpponent,
    BlockersTable,
    StudyFiltersPills,
    UnSwitcherNew,
    GwVideoPlayer,
  },
  mixins: [swipe_mix],
  props: {
    namespace: { type: String, required: true },
    canAISolve: { required: true, type: Boolean },
    showFlopContent: Boolean,
    solution_picked: { default: () => [] },
    tableGroups: { default: () => [] },
    combos: { default: () => [] },
    filterCategories: { default: () => [] },
    players: { default: () => [] },
    blockersFrequencies: Array,
    catDraws: Array,
    catHands: Array,
    catEqBuckets: Array,
    catEqBucketsAdvanced: Array,
    heroLeft: Boolean,
    hSpot: Object,
    useHex: Boolean,
    solElite: Object,
    isPreflop: Boolean,
    soltab: String,
    street: String,
    hero: Object,
    opponent: Object,
    mobile: Boolean,
    grouping: String,
    showBetsIn: String,
    bettingInfo: Object,
    smallLayout: Boolean,
    hasMinify: Boolean,
    landScapeLayout: Boolean,
    hasTableTile: { type: Boolean, default: true },
    rangeTab: String,
    actionHighlighted: Object,

    heroGroupId: String,
    opponentGroupId: String,

    heroHand: Object,

    heroGroup: Object,
    opponentGroup: Object,
    heroHandsIds: { default: () => [] },
    opponentHandsIds: { default: () => [] },
    filteredHeroHandsIds: { default: () => [] },
    filteredOpponentHandsIds: { default: () => [] },

    viewProps: Object,
    filterCombos: Object,
    filterEvCompare: Object,
    evProps: Object,

    tableMouseover: Boolean,
    hasPremiumGameformat: Boolean,
    gameformat: Object,
    playersDetail: { default: () => [] },
  },
  data() {
    const sww = allSwitchers()
    this.optionsActions = sww.sw_tabs_actions.map(i => i.payload)
    return {}
  },
  methods: {
    handleEqChartMouseEnter(hands) {
      this.$store.dispatch('sol_detail_hover_chart', {
        hands,
        tableGroups: this.tableGroups,
      })
    },
    swpLeft(eventData, { swKey }) {
      if (eventData.e.gw_touchends) {
        // console.log('swpLeft', eventData.e.gw_touchends)
        // scroll ro the end (right) wait a bit and then switch on second swipe
        if (
          !eventData.e.gw_touchends.some(
            i => i.ist_right && !i.ist_first && Date.now() - i.ist_right_time > 444,
          )
        )
          return
      }
      // console.log(eventData.e.gw_touchends)
      this.$store.dispatch('switchers_set_next', { key: swKey, num: 1 })
    },
    swpRight(eventData, { swKey }) {
      if (eventData.e.gw_touchends) {
        // console.log('swpRight', eventData.e.gw_touchends)
        // allow for move back instantly on first swipe right
        // if scrolled to right scrolled to left wait a bit and then switch on second swipe
        if (
          !eventData.e.gw_touchends.some(
            i => i.ist_left && (i.ist_first || Date.now() - i.ist_left_time > 444),
          )
        )
          return
      }
      this.$store.dispatch('switchers_set_next', { key: swKey, num: -1 })
    },
  },
  computed: {
    activeHandsForPlayers() {
      return this.playersDetail.map(player => player?.hands_ids || [])
    },
    playerDetail() {
      return this.playersDetail[this.viewProps.player]
    },
    actiontab() {
      return this.$store.getters.sw_tabs_actions
    },
    tabBreakdown() {
      return this.soltab === 'breakdown'
    },
    streamVideo() {
      const stream_url = this.gameformat.stream_url

      // Extract src after the last "/"
      const lastSlashIndex = stream_url.lastIndexOf('/')
      const src = lastSlashIndex !== -1 ? stream_url.slice(lastSlashIndex + 1).split('?')[0] : null

      // Extract start time after &t=
      const timeIndex = stream_url.indexOf('&t=')
      const start =
        timeIndex !== -1 ? parseInt(stream_url.slice(timeIndex + 3).split('&')[0], 10) : 0

      return { src, start }
    },
  },
}
</script>
<style lang="scss" scoped>
.sttranasd {
  --gap: var(--laytsttd-gap, 0.5rem);
  gap: var(--gap);

  flex-direction: column;
  display: flex;
  flex: 1;

  min-height: 0;
  min-width: 0;

  &_tabbox {
    --tbbox-content-gap: var(--laytsttd-gap) !important;
    --tbbox-content-padding: var(--laytsttd-padding-content) !important;
  }
}
</style>
